import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const Insurance = () => {
    const { t, i18n } = useTranslation();
    const [insurances, setInsurances] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchInsurances = async () => {
            try {
                const res = await axios.get('https://hasanhaji.com/api/insurance');
                setInsurances(res.data);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching insurances:', err);
                setLoading(false);
            }
        };

        fetchInsurances();
    }, []);

    return (
        <div className="container py-5">
            <h2 className="section-title">{t('home.insurance.title')}</h2>

            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">{t('home.insurance.loading')}</span>
                    </div>
                </div>
            ) : insurances.length === 0 ? (
                <div className="text-center py-5">
                    <i className="fas fa-shield-alt fa-3x text-muted mb-3"></i>
                    <p className="text-muted">{t('home.insurance.noInsurance')}</p>
                </div>
            ) : (
                <div className="row g-4 justify-content-center">
                    {insurances.map((insurance) => (
                        <div key={insurance.id} className="col-6 col-md-4 col-lg-3">
                            <div className="card h-100 shadow-sm border-0 insurance-card">
                                <div className="card-body d-flex align-items-center justify-content-center p-4">
                                    <img
                                        src={insurance.imageUrl}
                                        alt={insurance.name || 'Insurance Company'}
                                        className="img-fluid"
                                        style={{ maxHeight: '100px', objectFit: 'contain' }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                </div>
                                {insurance.name && (
                                    <div className="card-footer bg-transparent border-0 text-center">
                                        <h5 className="card-title fs-6 text-muted">{insurance.name}</h5>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Insurance;
